import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Button } from "antd";

function Header({ toggleCollapsed, collapsed, isMobile }) {
  
  if(!isMobile) return <></>
   return (
    <div className={`main-header-box ${!isMobile ? "h-10" : ""}`}>
      <div className="header-left-box">
        {isMobile && (
          <Button onClick={toggleCollapsed} className="toggle-btn">
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </Button>
        )}
        {/* <div className="header-title">AI Calling Agent</div> */}
      </div>
    </div>
  );
}

export default Header;
